import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=e1306a18&scoped=true&"
import script from "./order-list.vue?vue&type=script&lang=js&"
export * from "./order-list.vue?vue&type=script&lang=js&"
import style0 from "./order-list.vue?vue&type=style&index=0&id=e1306a18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1306a18",
  null
  
)

export default component.exports